<template>
  <div>
    <b-modal
      title="File Upload Utility"
      ref="imageDropZoneAndCropper"
      id="imageDropZoneAndCropperId"
      size="lg"
      hide-footer
    >
      <files-upload-with-cropper v-if="!uploading" @input="uploadFiles" :showUploadDate="showUploadDate" />
      <div v-else>
        <b-progress
          :value="uploadPercent"
          :max="100"
          show-progress
          animated
        ></b-progress>
      </div>
    </b-modal>
    <a @click="openImageUploadModal" :hidden="viewOnly"
      ><div style="display:flex ;flex-direction:row;gap:5%">
        <div style="padding-top:0.5%"><u style="font-weight:600; font-family:Verdana, Geneva, Tahoma, sans-serif;font-size:13px;">Choose file</u></div>
         <div>
         <feather-icon icon="UploadIcon" size="15" style="font-weight:600;font-family:Verdana, Geneva, Tahoma, sans-serif" />
         </div>
      </div> 
    </a>
    <b-row class="mt-1">
      <div
        v-for="(file, file_index) in value"
        :key="'images-' + file_index"
        class="px-1"
        style="width:14rem ;overflow-wrap: break-word;"
      >
        <a class="mt-1" @click="openFile(file)" v-if="checkIfImage(file)">
          {{ file_index + 1 }}-<u>{{
            file && file[0]
              ? file[0]
              : file
              ? getImgSrc(file).split("/").slice(-1).toString()
              : ""
          }}</u>
          <b-img
            :src="getImgSrc(file)"
            v-bind="imgProps"
            rounded="circle"
            class="ml-1"
            alt="Circle image"
          ></b-img
        ></a>
        <a class="mt-1" @click="openFile(file)" v-else>
          {{ file_index + 1 }}-<u>{{
            file && file[0]
              ? file[0]
              : file
              ? getImgSrc(file).split("/").slice(-1).toString()
              : ""
          }}</u>

          <b-img
            :src="filesDefaultImg"
            v-bind="imgProps"
            rounded="circle"
            alt="Circle image"
          ></b-img
        ></a> <br>
        <b-badge variant="secondary" v-if="file[2] && showUploadDate"> {{moment(file[2]).format('DD-MM-YYYY')}} </b-badge>
        <feather-icon
          size="20"
          s
          style="cursor: pointer; color: red"
          @click="() => {
            showModal(
              `Are you sure you want to delete ${file[0]}? This action is permanent and cannot be undone.`, 
              'save'
            ).then((value) => {
              if (value) removeFile(file_index);
            });
          }"
          icon="XCircleIcon"
          :hidden="viewOnly"
        />
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  BBadge,
  BCol,
  BRow,
  VBTooltip,
  BModal,
  BButton,
  BProgress,
  BCard,
  BCardText,
  BImg,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import FilesUploadWithCropper from "./FilesUploadWithCropper.vue";
import { uploadMultiFiles } from "@/utils/helpers";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import showModal from "../../components/ModalConfirmation";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BBadge,
    BCol,
    BRow,
    FeatherIcon,
    VBTooltip,
    BModal,
    FilesUploadWithCropper,
    BButton,
    BProgress,
    BCard,
    BCardText,
    BImg,
  },
  watch: {
    value: {
      handler: 'initializeFiles',
      immediate: true,
      deep: true
    }
  },
  created() {
    this.initializeFiles();
  },

  data() {
    return {
      imgProps: {
        blank: false,
        blankColor: "#777",
        width: 25,
        height: 25,
        class: "m1",
      },
      uploading: false,
      uploadPercent: 0,
      filesDefaultImg: require("@/assets/images/pages/files-documents.png"),
      internalFiles: [],
      moment: moment,
    };
  },

  props: {
    value: {
      type: [Object, Array],
      default: () => [],
    },
    show_only: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    showUploadDate: Boolean,
  },
  computed: {
    files_url() {
      return process.env.VUE_APP_FILESURL+ "/";
    },
  },
  methods: {
    showModal,
    initializeFiles() {
      this.internalFiles = Array.isArray(this.value) ? JSON.parse(JSON.stringify(this.value)) : [];
    },
    getFileName(file) {
      if (Array.isArray(file)) {
        return file[0];
      } else {
        return "";
      }
    },
    getImgSrc(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          return this.files_url + file[1];
        }
      } else {
        return this.files_url + file;
      }
    },

    openImageUploadModal() {
      this.$refs["imageDropZoneAndCropper"].show();
    },
     emitInput(files) {
       this.$emit("input", files);
     },
    onUploadProgress(progressEvent) {
      this.uploadPercent = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },

    async uploadFiles(files) {
      this.uploading = true;
      try {
        const filesArr = files.map((f) => f[1]);

        const uploadPaths = await uploadMultiFiles(
          filesArr,
          this.onUploadProgress
        );

        if (uploadPaths && Array.isArray(uploadPaths) && uploadPaths.length) {
          let filesArr =
            this.value && Array.isArray(this.value) ? this.value : [];
          let newArr;
          if(this.showUploadDate) {
            newArr = uploadPaths.map((uploadPath, index) => [
              files[index][0],
              uploadPath,
              files[index][2],
            ]);
          } else {
            newArr = uploadPaths.map((uploadPath, index) => [
              files[index][0],
              uploadPath,
            ]);
          }

          filesArr = filesArr.concat(newArr);

          this.emitInput(filesArr);
          this.$refs["imageDropZoneAndCropper"].hide();
        }
      } catch (err) {
        console.error("Error in uploadFiles ", err);
      } finally {
        this.uploading = false;
        this.uploadPercent = 0;
      }
    },

    removeFile(file_index) {
      console.log(this.internalFiles,'before removal') ;
      const updatedFiles = this.internalFiles.filter((_, index) => index !== file_index);
      this.emitInput(updatedFiles);
      this.$emit("remove", updatedFiles);
      console.log(updatedFiles,'emitted files after removal') ;
    },

    openFile(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          window.open(this.files_url + file[1], "__blank");
        }
      } else {
        window.open(this.files_url + file, "__blank");
      }
    },

    checkIfImage(file) {
      if (!file) return false;

      let uploadPath = "";
      if (Array.isArray(file)) {
        uploadPath = file[1];
      } else {
        uploadPath = file;
      }

      if (
        typeof uploadPath === "string" &&
        uploadPath.match(/\.(png|jpg|jpeg|webp)$/)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.uploadDivContainer {
  border: solid 2px orange;
  border: 5px solid #f3f2f7;
  cursor: pointer;
  width: 100px;
  aspect-ratio: auto 100 / 100;
  /* height: 100px; */
  text-align: center;
}
.upload-icon {
  height: 45px !important;
  width: 60px !important;
  padding: 0.25rem;
  background-color: #edefff;
  /* background-color: #1f307a; */
  border: 1px solid #dae1e7;
  border-radius: 0.357rem;
}
.f-10 {
  font-size: 8px;
  font-weight: bolder;
}
.file-name {
  /* ----for showing full name---- */
  height: 1em;
  line-height: 1em;
  overflow: hidden;
  /* ----for showing dots---- */
  /* display: inline-block;
  width: 90%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis; */
}
img {
  /* height: 200px !important; */
  /* width: 150px !important; */
}
</style>
